
    <!--
 * 竖版-全局弹窗
 * @LastEditTime: Tue Dec 17 2024 15:43:17 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_EPKV20"  :class="[`normal`,`u_c_EPKV20`]" ><div id="u_c_I48K21"  v-show="compData.previewPopup == 'bind' || pageData.bindPopupState" :class="[`normal popup`,`u_c_I48K21`]" @click="u_c_I48K21_event_F8M123($event)"><div id="u_c_1OB822"  :class="[`normal popup-content-small`,`u_c_1OB822`]" @click="u_c_1OB822_event_2MZ224($event)"><div id="u_c_4UE223"  :class="[`normal popup-title popup-title-color`,`u_c_4UE223`]" >{{`${ langData.bindTitle }`}}</div><div id="u_c_YUHB25"  :class="[`normal`,`u_c_YUHB25`]" ><div id="u_c_CQKU26"  :class="[`normal select-item `,`u_c_CQKU26`]" ><select id="u_c_GZMD27"  v-model="pageData.serverItem" :class="[`normal select-item-select `,`u_c_GZMD27`]" ><option id="u_c_8QQF28" disabled="disabled" :value="defaultServerItem" :class="[`normal`,`u_c_8QQF28`]" >{{`${ langData.selectServer }`}}</option><optgroup id="u_c_ZIPQ30"  :label="langData.yourServer" :class="[`normal`,`u_c_ZIPQ30`]" ><option id="u_c_02BK31"  v-for="(sItem, sIndex) in pageData.recentServerList" :key="sIndex" :value="sItem" :class="[`normal`,`u_c_02BK31`]" >{{`${ sItem.sname }`}}</option></optgroup><optgroup id="u_c_D17Q33"  :label="langData.allServer" :class="[`normal`,`u_c_D17Q33`]" ><option id="u_c_1T3P34"  v-for="(sItem, sIndex) in pageData.serverList" :key="sIndex" :value="sItem" :class="[`normal`,`u_c_1T3P34`]" >{{`${ sItem.sname }`}}</option></optgroup></select></div><div id="u_c_EBOH36"  :class="[`normal select-item`,`u_c_EBOH36`]" ><select id="u_c_46K737"  v-model="pageData.roleIndex" :class="[`normal select-item-select `,`u_c_46K737`]" ><option id="u_c_ZXZE38"  v-for="(rItem, rIndex) in pageData.roleList" :key="rIndex" :value="rIndex" :class="[`normal`,`u_c_ZXZE38`]" >{{`${ rItem.roleName }`}}</option></select></div></div><a id="u_c_2UDV40" href="javascript:;" :class="[`normal sure`,`u_c_2UDV40`]" @click="u_c_2UDV40_event_QSVC19($event)">{{`${ langData.bindBtn }`}}</a><div id="u_c_EELD42"  v-html="langData.canNoReBind" v-show="!pageData.canReBind" :class="[`normal txt-size tips-color`,`u_c_EELD42`]" ></div><a id="u_c_IXTY43" href="javascript:;" :class="[`normal popup-close`,`u_c_IXTY43`]" @click="u_c_IXTY43_event_DMX517($event)"></a></div></div><div id="u_c_J40V44"  v-show="compData.previewPopup == 'bag' || pageData.bagPopupState" :class="[`normal popup`,`u_c_J40V44`]" @click="u_c_J40V44_event_F8M123($event)"><div id="u_c_G90Y45"  :class="[`normal popup-content-big`,`u_c_G90Y45`]" @click="u_c_G90Y45_event_2MZ224($event)"><div id="u_c_F3OS46"  :class="[`normal popup-title popup-title-color`,`u_c_F3OS46`]" >{{`${ langData.myPackage }`}}</div><div id="u_c_JBXQ48"  :class="[`normal border-color`,`u_c_JBXQ48`]" ><table id="u_c_J9YU49"  :class="[`normal`,`u_c_J9YU49`]" ><thead id="u_c_ZVJ350"  :class="[`normal`,`u_c_ZVJ350`]" ><td id="u_c_8WD951"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_8WD951`]" >{{`${ langData.packageTime }`}}</td><td id="u_c_ZT6B53"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_ZT6B53`]" >{{`${ langData.packageName }`}}</td></thead><tbody id="u_c_CW1R55"  :class="[`normal`,`u_c_CW1R55`]" ><tr id="u_c_6SM956"  v-for="(packItem, pI) in pageData.myPackageList" :key="pI" :class="[`normal border-color tr `,`u_c_6SM956`]" ><td id="u_c_DMOQ57"  :class="[`normal td border-color txt-size txt-color`,`u_c_DMOQ57`]" >{{`${ packItem.award_time }`}}</td><td id="u_c_DOWL59"  :class="[`normal td border-color txt-size txt-color`,`u_c_DOWL59`]" ><span id="u_c_7W3S60"  v-html="packItem.award_name || giftInfo[packItem.award_block] && giftInfo[packItem.award_block][+packItem.send_id - 1] && giftInfo[packItem.award_block][+packItem.send_id - 1].name || ''" :class="[`normal`,`u_c_7W3S60`]" ></span><span id="u_c_JC4161"  v-html="`${ langData.giftCode }：${ packItem.award_code }`" v-show="packItem.send_type == 'sendSerial'" :class="[`normal`,`u_c_JC4161`]" ></span><a id="u_c_YZRB62" href="javascript:;" v-show="packItem['send_type'] == 'sendCoupon'" :class="[`normal popup-title-color txt-size`,`u_c_YZRB62`]" @click="u_c_YZRB62_event_1JVM17($event)">{{`[${ langData.useBtn }]`}}</a><a id="u_c_8QYO64" href="javascript:;" v-show="packItem['send_type'] == 'sendSerial'" :class="[`normal txt-size popup-title-color`,`u_c_8QYO64`]" @click="u_c_8QYO64_event_QX7K17($event,packItem.award_code)">{{`[${ langData.copyAndGoExchange }]`}}</a></td></tr></tbody></table><div id="u_c_YHLR66"  v-html="langData.emptyBag" v-show="!pageData.myPackageList.length" :class="[`normal txt-size txt-color`,`u_c_YHLR66`]" ></div></div><a id="u_c_GD8367" href="javascript:;" :class="[`normal popup-close`,`u_c_GD8367`]" @click="u_c_GD8367_event_DMX517($event)"></a></div></div><div id="u_c_JBXS68"  v-show="compData.previewPopup == 'tips' || pageData.tipsPopupState" :class="[`normal popup`,`u_c_JBXS68`]" @click="u_c_JBXS68_event_TETB35($event)"><div id="u_c_FLPV69"  :class="[`normal popup-content-small`,`u_c_FLPV69`]" @click="u_c_FLPV69_event_U82518($event)"><div id="u_c_8UMN70"  :class="[`normal popup-title-color popup-title`,`u_c_8UMN70`]" >{{`${ pageData.tips }`}}</div><a id="u_c_AMGH72" href="javascript:;" :class="[`normal sure`,`u_c_AMGH72`]" @click="u_c_AMGH72_event_V0IC67($event)">{{`${ langData.sureBtn }`}}</a><a id="u_c_EVGO74" href="javascript:;" :class="[`normal popup-close`,`u_c_EVGO74`]" @click="u_c_EVGO74_event_DMX517($event)"></a></div></div><div id="u_c_DSXT75"  v-show="compData.previewPopup == 'previewGift' || pageData.seeGiftPopupState" :class="[`normal popup`,`u_c_DSXT75`]" @click="u_c_DSXT75_event_TETB35($event)"><div id="u_c_HPWW76"  :class="[`normal popup-content-small`,`u_c_HPWW76`]" @click="u_c_HPWW76_event_U82518($event)"><div id="u_c_ZKSL77"  :class="[`normal popup-title-color popup-title`,`u_c_ZKSL77`]" >{{`${ langData.checkGiftBtn }`}}</div><div id="u_c_Z9SF79"  :class="[`normal `,`u_c_Z9SF79`]" ><table id="u_c_HBYF80"  :class="[`normal`,`u_c_HBYF80`]" ><tbody id="u_c_98EV81"  :class="[`normal`,`u_c_98EV81`]" ><tr id="u_c_DJ6M82"  v-for="(seeItem, seeIndex) in pageData.seeGift" :key="seeIndex" :class="[`normal border-color  tr `,`u_c_DJ6M82`]" ><td id="u_c_4ON683"  :class="[`normal td border-color txt-size txt-color`,`u_c_4ON683`]" ><img id="u_c_5A9Y84"  :src="seeItem.pic" v-show="seeItem.pic" :class="[`normal`,`u_c_5A9Y84`]" /></td><td id="u_c_ISS685"  :class="[`normal td border-color txt-size txt-color`,`u_c_ISS685`]" ><div id="u_c_08ZY86"  v-html="seeItem.name" :class="[`normal`,`u_c_08ZY86`]" ></div></td></tr></tbody></table></div><a id="u_c_BRQF87" href="javascript:;" :class="[`normal popup-close`,`u_c_BRQF87`]" @click="u_c_BRQF87_event_DMX517($event)"></a></div></div><div id="u_c_EHPW88"  v-show="compData.previewPopup == 'daoju' || pageData.propsPopupState" :class="[`normal popup`,`u_c_EHPW88`]" @click="u_c_EHPW88_event_TETB35($event)"><div id="u_c_IOX689"  :class="[`normal popup-content-big`,`u_c_IOX689`]" @click="u_c_IOX689_event_U82518($event)"><div id="u_c_83CB90"  :class="[`normal popup-title popup-title-color`,`u_c_83CB90`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_0RUO92"  :class="[`normal`,`u_c_0RUO92`]" ><div id="u_c_22F993"  :class="[`normal`,`u_c_22F993`]" ><div id="u_c_YMZE94"  v-html="pageData.curGiftName" :class="[`normal txt-size txt-color`,`u_c_YMZE94`]" ></div></div><img id="u_c_22A595"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal`,`u_c_22A595`]" /></div><a id="u_c_6OXR96" href="javascript:;" :class="[`normal sure`,`u_c_6OXR96`]" @click="u_c_6OXR96_event_YU9U68($event)">{{`${ langData.sureBtn }`}}</a><div id="u_c_IGPN98"  v-html="langData.daojuTips" :class="[`normal tips-color txt-size`,`u_c_IGPN98`]" ></div><a id="u_c_EM2I99" href="javascript:;" :class="[`normal popup-close`,`u_c_EM2I99`]" @click="u_c_EM2I99_event_DMX517($event)"></a></div></div><div id="u_c_5R8F100"  v-show="compData.previewPopup == 'youhuiquan' || pageData.quanPopupState" :class="[`normal popup`,`u_c_5R8F100`]" @click="u_c_5R8F100_event_TETB35($event)"><div id="u_c_2BKH101"  :class="[`normal popup-content-big`,`u_c_2BKH101`]" @click="u_c_2BKH101_event_U82518($event)"><div id="u_c_E8TO102"  :class="[`normal popup-title popup-title-color`,`u_c_E8TO102`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_C672104"  :class="[`normal`,`u_c_C672104`]" ><div id="u_c_1MD4105"  :class="[`normal`,`u_c_1MD4105`]" ><div id="u_c_H54V106"  v-html="pageData.curGiftName" :class="[`normal txt-size txt-color`,`u_c_H54V106`]" ></div></div><img id="u_c_3NFV107"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal`,`u_c_3NFV107`]" /></div><a id="u_c_BTH6108" href="javascript:;" :class="[`normal  sure`,`u_c_BTH6108`]" @click="u_c_BTH6108_event_35V252($event)">{{`${ langData.useBtn }`}}</a><a id="u_c_9BQD110" href="javascript:;" :class="[`normal popup-close`,`u_c_9BQD110`]" @click="u_c_9BQD110_event_DMX517($event)"></a></div></div><div id="u_c_2XPV111"  v-show="compData.previewPopup == 'xuhao' || pageData.giftCodePopupState" :class="[`normal popup`,`u_c_2XPV111`]" @click="u_c_2XPV111_event_TXZS38($event)"><div id="u_c_DB6Y112"  :class="[`normal popup-content-small`,`u_c_DB6Y112`]" @click="u_c_DB6Y112_event_EKU139($event)"><div id="u_c_7UKR113"  :class="[`normal popup-title popup-title-color`,`u_c_7UKR113`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_Z6D0115"  :class="[`normal`,`u_c_Z6D0115`]" ><div id="u_c_2BKA116"  :class="[`normal txt-size txt-color`,`u_c_2BKA116`]" >{{`${ langData.giftCode }：${ pageData.curGiftName }`}}</div><a id="u_c_XYF6118" href="javascript:;" :class="[`normal txt-size popup-title-color`,`u_c_XYF6118`]" @click="u_c_XYF6118_event_QX7K17($event)">{{`[${ langData.copy }]`}}</a></div><div id="u_c_B9NJ120" href="javascript:;" :class="[`${ compData.copyTipsState ? '' : 'hide' }`,`normal txt-size txt-color`,`u_c_B9NJ120`]" >{{`${ langData.copySucc }`}}</div><a id="u_c_BSRV122" href="javascript:;" :class="[`normal popup-close`,`u_c_BSRV122`]" @click="u_c_BSRV122_event_KBHJ41($event)"></a><a id="u_c_F9TM123" href="javascript:;" :class="[`normal sure`,`u_c_F9TM123`]" @click="u_c_F9TM123_event_YU9U68($event)">{{`${ langData.gotoExchange }`}}</a></div></div><div id="u_c_GAB2125"  v-show="compData.previewPopup == 'info' || pageData.infoPopupState" :class="[`normal popup`,`u_c_GAB2125`]" @click="u_c_GAB2125_event_TETB35($event)"><div id="u_c_2FB6126"  :class="[`normal popup-content-big`,`u_c_2FB6126`]" @click="u_c_2FB6126_event_U82518($event)"><div id="u_c_37SC127"  :class="[`normal popup-title popup-title-color`,`u_c_37SC127`]" >{{`${ langData.infoBtn }`}}</div><div id="u_c_1KND129"  v-html="compData.infoContent" :class="[`normal txt-size txt-color`,`u_c_1KND129`]" ></div><a id="u_c_FFZT130" href="javascript:;" :class="[`normal popup-close`,`u_c_FFZT130`]" @click="u_c_FFZT130_event_DMX517($event)"></a></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import useClipboard from "vue-clipboard3"

    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"infoContent":`1.活动介绍
（1）【成神归来 每日赠礼】
①活动期间，每日通过官网储值任意金额，即可领取首充奖励；
②当日首充奖励需在当日领取完毕，逾期失效，不可补领；

（2）【九考特训 签到送好礼】
①活动期间，每日登入活动页面，即可完成签到，累计签到天数达到1、3、7、12、14天后，即可领取签到奖励；
②每个档位的奖励，每个账号只能领取一次；
③未领取的奖励可在活动结束后7天内继续领取，7天后失效；


（3）【天使的选择】
①活动期间，通过官网储值日储值满5美金，每日可获得3次机会开启盲盒
②消耗一张抽奖券可以进行对应次数开盲盒，随机获得奖池内奖励
③抽奖券不会进行每天重置，需要在活动期间内进行使用，逾期无效。

（4）【成神祝福赠礼】
①活动期间，在【天使盲盒 】中累计消耗的抽奖券达到一定的数量，可以解锁领取对应的奖励；
②累计消耗数量针对整个活动期间进行统计，不会进行每天重置；
③未领取的奖励可在活动结束后7天内继续领取，7天后失效；


2.奖励发放
奖励将会直接发放至游戏内邮件处，可通过游戏内邮件查收

3.活动最终解释权归《斗罗大陆3D：魂师对决》运营团队所有。`,"copyTipsState":false,"previewPopup":``},"zh-CN":{"infoContent":`首储赠礼
活动期间，通过【官网储值页面】任意渠道成功储值任意金额，即可领取奖励，每个账号只能领取一次；
未领取的奖励可在活动结束后7天内继续领取，7天后失效；

每日签到送不停
活动期间，每日登入活动页面，即可完成签到，累计签到天数达到1、3、5、7天后，即可领取签到奖励；
每个档位的奖励，每个账号只能领取一次；
未领取的奖励可在活动结束后7天内继续领取，7天后失效；
庆典豪华礼盒
活动期间，通过【官网储值页面】任意渠道储值，每天累计储值金额每次达到19.99USD，都会获得一张抽奖券；
消耗一张抽奖券可以进行一次抽奖，随机获得奖池内奖励；
单日获得抽奖券上限100张；
抽奖券不会进行每天重置，需要在活动期间内进行使用，逾期无效;
二重好礼
活动期间，累计消耗的抽奖券达到一定的数量，可以解锁领取对应的奖励；
未领取的奖励可在活动结束后7天内继续领取，7天后失效；`,"copyTipsState":false,"previewPopup":``},"zh-TW":{"infoContent":`首儲贈禮
活動期間，通過【官網儲值頁面】任意管道成功儲值任意金額，即可領取獎勵，每個帳號只能領取一次；
未領取的獎勵可在活動結束後7天內繼續領取，7天後失效；

每日簽到送不停
活動期間，每日登入活動頁面，即可完成簽到，累計簽到天數達到1、3、5、7天後，即可領取簽到獎勵；
每個檔位的獎勵，每個帳號只能領取一次；
未領取的獎勵可在活動結束後7天內繼續領取，7天后失效；
慶典豪華禮盒
活動期間，通過【官網儲值頁面】任意管道儲值，每天累計儲值金額每次達到19.99USD，都會獲得一張抽獎券；
消耗一張抽獎券可以進行一次抽獎，隨機獲得獎池內獎勵；
單日獲得抽獎券上限100張；
抽獎券不會進行每天重置，需要在活動期間內進行使用，逾期無效;
二重好禮
活動期間，累計消耗的抽獎券達到一定的數量，可以解鎖領取對應的獎勵；
未領取的獎勵可在活動結束後7天內繼續領取，7天后失效；`,"copyTipsState":false,"previewPopup":``},"en-US":{"infoContent":`1st Top-up Gift
During the event, top up on Puzzles & Survival's official website to obtain a reward. The reward can only be claimed once per account.
Unclaimed rewards will expire 7 days after the event ends.

Daily Sign-in Reward
Log in to the event page every day to sign in. Sign in for 1/3/5/7 day(s) to claim sign-in rewards.
Each tier of rewards can only be claimed once per account.
Unclaimed rewards will expire 7 days after the event ends.

Deluxe Anniversary Box
During the event, every 19.99USD you top up every day via Puzzles & Survival's official website will grant you a Lucky Ticket.
Use a Lucky Ticket to draw once to get random rewards.
You can obtain up to 100 Lucky Tickets every day.
Your Lucky Tickets won't reset every day, but be sure to use them before the event ends.

Bonus Gift
Corresponding rewards will be unlocked when the total number of Lucky Tickets you used reaches a certain amount.
Unclaimed rewards will expire 7 days after the event ends.`,"copyTipsState":false,"previewPopup":``},"ja-JP":{"infoContent":`初回チャージ ボーナス
イベント期間中、「公式チャージ画面」にて任意の決済方法で任意の金額をチャージすると、ボーナスを受け取れます！（1つのアカウントにつき1回のみ）
未受領のボーナスはイベント終了から7日間は受け取ることができます。

毎日ログイン　ボーナス続々
イベント期間中、毎日イベント画面からログインするとサインインが完了します。合計サインイン日数が1、3、5、7日に到達すると、対応するボーナスを受け取れます。
1つのアカウントにつき各ボーナスを1回ずつ受取可能
未受領のボーナスはイベント終了から7日間は受け取ることができます。
ミュージックフェスパックでボーナスゲット
イベント期間中、「公式チャージ画面」にて任意の決済方法で一日の合計チャージが19.99USDに達するたびに、抽選券を獲得できます。
1枚の抽選券を消費し、ランダムボーナスを獲得できます。
1日につき最大100枚の抽選券を獲得できます。
抽選券はイベント期間中に更新されず、イベント終了後に使用できなくなります。
豪華ボーナス
イベント期間中、抽選で合計消費した抽選券の枚数が一定値に達すると対応するボーナスを獲得できます。
未受領のボーナスはイベント終了から7日間は受け取ることができます。`,"copyTipsState":false,"previewPopup":``},"ko-KR":{"infoContent":`첫 충전 
혜택
이벤트 기간에 공식 결제 플랫폼에서 금액 관계 없이 충전만 하면 보상을 획득합니다. (계정당 한 번만 가능!)
"미수령 보상은 이벤트 종료 후 7일 내에만 수령 가능하며, 그 후에는 사라집니다."

매일 출석하면 선물이 팡팡
"이벤트 기간 동안 이벤트 페이지에 매일 접속하여 출석을 완료하면, 누적 출석 일수 1, 3, 5, 7일마다 출석 보상을 획득합니다."
단계별 보상은 계정당 한 번만 받을 수 있습니다.
"미수령 보상은 이벤트 종료 후 7일 내에만 수령 가능하며, 그 후에는 사라집니다."
뮤직 페스티벌 패키지 대상 받기
이벤트 기간 동안 공식 결제 플랫폼에서 19.99USD를 충전할 때마다 뽑기권 한 장이 주어집니다. 누적 충전 금액이 매일 리셋됩니다.
뽑기권 한 장을 사용해 뽑기를 한 번 돌리면 보상풀의 보상을 랜덤으로 획득합니다.
뽑기권은 일일 최대 100장까지만 획득 가능합니다.
"뽑기권은 다음 날에도 초기화되지 않으나 이벤트 기간 내에 사용하셔야 하며, 기간 종료 시 무효가 됩니다."
더블 보너스
"이벤트 기간 동안 뽑기권 누적 소모량이 일정 개수에 도달하면, 상응하는 보상을 받을 수 있습니다."
"미수령 보상은 이벤트 종료 후 7일 내에만 수령 가능하며, 그 후에는 사라집니다."`,"copyTipsState":false,"previewPopup":``},"th-TH":{"infoContent":`เติมครั้งแรกมีรางวัล
ช่วงกิจกรรม เพียงเติมเงินผ่าน [หน้าเพจเว็บไซต์ทางการ] สำเร็จ ก็สามารถรับรางวัลได้ (รับได้บัญชีละ 1 ครั้ง)
สามารถรับรางวัลที่ยังไม่ได้รับต่อภายใน 7 วันหลังกิจกรรมสิ้นสุดได้

เช็คอินแล้ว รับรางวัลทันที
"ทุกวันที่เปิดหน้ากิจกรรมในช่วงกิจกรรม ก็จะถือว่าเช็คอินเสร็จสิ้น เมื่อเช็คอินสะสมครบ 1, 3, 5 และ 7 วัน จะรับรางวัลเช็คอินได้"
แต่ละบัญชีสามารถรับรางวัลได้ระดับละ 1 ครั้ง
สามารถรับรางวัลที่ยังไม่ได้รับต่อภายใน 7 วันหลังกิจกรรมสิ้นสุดได้

กล่องสุดหรูงานฉลอง
ช่วงกิจกรรม เพียงเติมเงินผ่าน [หน้าเพจเว็บไซต์ทางการ] สะสมครบครั้งละ 19.99USD ก็จะได้รับคูปองจับรางวัล 1 ใบ
ใช้คูปองจับรางวัล 1 ใบ จะจับรางวัลได้ 1 ครั้ง และสุ่มได้รางวัลภายใน Prize Pool :
รับคูปองจับรางวัลได้สูงสุดวันละ 100 ใบ
คูปองจับรางวัลจะไม่ถูกรีเซ็ตทุกวัน แต่ต้องใช้ในช่วงกิจกรรมเท่านั้น
รางวัล 2 ชั้น
ช่วงกิจกรรมใช้คูปองจับรางวัลถึงจำนวนที่กำหนด ก็สามารถรับรางวัลที่สอดคล้องได้
สามารถรับรางวัลที่ยังไม่ได้รับต่อภายใน 7 วันหลังกิจกรรมสิ้นสุดได้`,"copyTipsState":false,"previewPopup":``},"vi-VN":{"infoContent":`Tặng quà nạp đầu
"Trong thời gian hoạt động, nạp mức bất kỳ trên kênh bất kỳ là có thưởng, mỗi tài khoản chỉ được lấy một lần;"
"Thưởng chưa lấy có thể lấy tiếp trong 7 ngày sau khi kết thúc hoạt động, 7 ngày sau vô hiệu;"

Điểm Danh Hàng Ngày Nhận Quà Liền Tay
"Trong thời gian hoạt động, đăng nhập giao diện hoạt động mỗi ngày là hoàn thành điểm danh, sau khi điểm danh đến 1, 3, 5, 7 ngày là được nhận thưởng điểm danh;"
"Mỗi mức thưởng, mỗi tài khoản chỉ được lấy một lần;"
"Thưởng chưa lấy có thể lấy tiếp trong 7 ngày sau khi kết thúc hoạt động, 7 ngày sau vô hiệu;"
Thưởng thắng Gói Hội Âm Nhạc
"Trong thời gian hoạt động, Nạp thông qua kênh bất kỳ, mỗi lần tích lũy nạp đến 19.99 USD, để nhận một tấm Vé Rút Thưởng;"
"Tiêu phí một tấm Vé Rút Thưởng là có thể rút thưởng một lần, nhận thưởng ngẫu nhiên trong quỹ thưởng;"
Mỗi ngày giới hạn nhận 100 tấm Vé Rút Thưởng;
"Vé Rút Thưởng sẽ không reset hàng ngày, phải sử dụng trong thời gian diễn ra hoạt động, quá hạn vô hiệu;"
Quà Thêm
"Trong thời gian hoạt động, tích lũy tiêu hao số Vé Rút Thưởng chỉ định, là mở khóa phần thưởng tương ứng;"
"Thưởng chưa lấy có thể lấy tiếp trong 7 ngày sau khi kết thúc hoạt động, 7 ngày sau vô hiệu;"`,"copyTipsState":false,"previewPopup":``},"de-DE":{"infoContent":`1. Auflade-Geschenk
Lade w?hrend des Events auf der offiziellen Webseite von Puzzles & Survival auf, um eine Belohnung zu erhalten. Die Belohnung kann nur einmal pro Konto abgeholt werden.
Nicht abgeholte Belohnungen verfallen 7 Tage nach Ende des Events.

T?gliche Anmeldebelohnung
Logge dich jeden Tag auf der Eventseite an, um dich anzumelden. Melde dich für 1/3/5/7 Tag(e) an, um Anmeldebelohnungen zu erhalten.
Jede Belohnungsstufe kann nur einmal pro Konto abgeholt werden.
Nicht abgeholte Belohnungen verfallen 7 Tage nach Ende des Events.
Deluxe Jubiläumskiste
"W?hrend des Events erh?ltst du für jede 19.99USD, die du jeden Tag über die offizielle Webseite von Puzzles & Survival aufl?dst, ein Glücksticket.
"
Verwende ein Glücksticket, um einmal zu ziehen und um zuf?llige Belohnungen zu erhalten.
Du kannst jeden Tag bis zu 100 Glückstickets erhalten.
Deine Glückstickets werden nicht jeden Tag zurückgesetzt, aber verwende sie unbedingt, bevor das Event endet.
Bonus-Geschenk
Die entsprechenden Belohnungen werden entsperrt, wenn die Gesamtzahl der von dir verwendeten Glückstickets eine bestimmte Menge erreicht.
Nicht abgeholte Belohnungen verfallen 7 Tage nach Ende des Events.
`,"copyTipsState":false,"previewPopup":``},"fr-FR":{"infoContent":`Cadeau de 1ère de Recharge
Pendant l'événement, rechargez votre compte sur le site officiel de Puzzles & Survival pour obtenir une récompense. La récompense ne peut être réclamée qu'une fois par compte.
Les récompenses non réclamées expireront 7 jours après la fin de l'événement.

Récompense de Connexion Quotidienne
Connectez-vous à la page de l'événement tous les jours pour vous connecter. Connectez-vous pendant 1/3/5/7 jour(s) pour réclamer les récompenses de connexion.
Chaque niveau de récompense ne peut être réclamé qu'une fois par compte.
Les récompenses non réclamées expireront 7 jours après la fin de l'événement.
Boîte Anniversaire Deluxe
"Pendant l'événement, chaque fois que vous rechargerez 19,99 USD par jour via le site officiel de Puzzles & Survival, vous obtiendrez un Ticket Chance.
"
Utilisez un Ticket Chanceux pour tirer au sort une fois et obtenir des récompenses aléatoires.
Vous pouvez obtenir jusqu'à 100 Tickets Chanceux par jour.
Vos Tickets Chanceux ne seront pas remis à zéro tous les jours, mais assurez-vous de les utiliser avant la fin de l'événement.
Cadeau Bonus
Les récompenses correspondantes seront débloquées lorsque le nombre total de Tickets Chanceux Tickets que vous avez utilisés atteindra un certain montant.
Les récompenses non réclamées expireront 7 jours après la fin de l'événement.
`,"copyTipsState":false,"previewPopup":``},"ru-RU":{"infoContent":`Подарок за 1-е Пополнение
Пополните счёт на официальном сайте ?Puzzles & Survival? во время события и получите награду. Такой приз можно получить лишь раз.
Непринятые награды устареют спустя 7 дней после окончания события.

Награда за Ежедневный Вход
Заходите на страницу события каждый день, чтобы заработать посещение. Посещайте в течение 1/3/5/7 дн. подряд, чтобы получить награду за вход.
Каждый уровень наград можно получить только один раз.
Непринятые награды устареют спустя 7 дней после окончания события.
Шикарный юбилейный ящик
"Каждое пополнение на сумму 19,99USD в день на официальном сайте ?Puzzles & Survival? принесёт вам Счастливый Билет во время события.
"
Используйте Счастливый Билет, чтобы поучаствовать в розыгрыше и получить случайные призы.
За день можно получить вплоть до 100 Счастливых Билетов.
Счастливые Билеты не сбрасываются каждый день, но их нужно использовать до окончания события.
Бонусный Подарок
Награды разблокируются после того, как вы используете определенное количество Счастливых Билетов.
`,"copyTipsState":false,"previewPopup":``},"es-ES":{"infoContent":`Regalo de la 1.a recarga
Durante el evento, haz una recarga en el sitio web oficial de Puzzles & Survival para obtener una recompensa. La recompensa solo se puede reclamar una vez por cuenta.
Las recompensas sin reclamar caducarán 7 días después de que finalice el evento.

Recompensa de inscripción diaria
Ingresa a la página del evento todos los días para registrarte. Regístrate por 1/3/5/7 día(s) para reclamar las recompensas de inicio de sesión.
Cada nivel de recompensas solo se puede reclamar una vez por cuenta.
Las recompensas sin reclamar caducarán 7 días después de que finalice el evento.
Caja de aniversario lujosas
Durante el evento, recibirás un ticket de la suerte por cada $19.99 que recargues todos los días en el sitio web oficial de Puzzles & Survival.
Usa un ticket de la suerte para sortear una vez y conseguir recompensas aleatorias.
Puedes obtener hasta 100 tickets de la suerte por día.
Tus tickets de la suerte no se reiniciarán cada día, pero asegúrate de usarlos antes de que termine el evento.
Regalo de bonificación
Las recompensas correspondientes se desbloquearán cuando la cantidad total de tickets de la suerte que hayas utilizado alcance una cantidad determinada.
Las recompensas sin reclamar caducarán 7 días después de que finalice el evento.
`,"copyTipsState":false,"previewPopup":``},"pt-PT":{"infoContent":`1o presente de recarga
Durante o evento, fa?a uma recarga no site oficial do Puzzles & Survival para obter uma recompensa. A recompensa só pode ser resgatada uma vez por conta.
As recompensas n?o reclamadas expirar?o 7 dias após o término do evento.

Recompensa de Login Diário
Fa?a login na página do evento todos os dias para fazer entrar. Fa?a login por 1/3/5/7 dia(s) para reivindicar recompensas de login.
Cada nível de recompensas só pode ser reivindicado uma vez por conta.
As recompensas n?o reclamadas expirar?o 7 dias após o término do evento.
Caixa de Aniversário Deluxe
"Durante o evento, cada $19,99 que você recarregar todos os dias através do site oficial do Puzzles & Survival, concederá a você um Bilhete da Sorte.
"
Use um Bilhete da Sorte para sortear uma vez e obter recompensas aleatórias.
Você pode obter até 100 Bilhetes da Sorte todos os dias.
Seus Bilhetes da Sorte n?o ser?o zerados todos os dias, mas certifique-se de usá-los antes do fim do evento.
Presente B?nus
As recompensas correspondentes ser?o desbloqueadas quando o número total de Bilhetes da Sorte que você usou atingir um determinado valor.
As recompensas n?o reclamadas expirar?o 7 dias após o término do evento.
`,"copyTipsState":false,"previewPopup":``},"it-IT":{"infoContent":`1mo Regalo Ricarica
Durante l'evento, ricarica sul sito ufficiale di Puzzles & Survival per ottenere una ricompensa. Il premio può essere richiesto solo una volta per account.
Sudah klaim

Ricompensa Accesso Giornaliero
Accedi alla pagina dell'evento ogni giorno per accedere. Accedi per 1/3/5/7 giorno/i per richiedere i premi di accesso.
Ogni livello di premi può essere richiesto solo una volta per account.
I premi non riscossi scadranno 7 giorni dopo la fine dell'evento.
Scatola Anniversario Deluxe
Durante l'evento, ogni $19,99 che ricarichi tramite il sito ufficiale di Puzzles & Survival ti garantirà un Biglietto Fortunato.
Usa un Biglietto Fortuna per pescare una volta per ottenere ricompense casuali.
Puoi ottenere fino a 100 Biglietti Fortuna ogni giorno.
I tuoi biglietti fortunati non verranno ripristinati ogni giorno, ma assicurati di utilizzarli prima della fine dell'evento.
Regalo Bonus
Le ricompense corrispondenti verranno sbloccate quando il numero totale di biglietti fortunati che hai utilizzato raggiunge un determinato importo.
I premi non riscossi scadranno 7 giorni dopo la fine dell'evento.
`,"copyTipsState":false,"previewPopup":``},"tr-TR":{"infoContent":`1. Yükleme Hediyesi
Etkinlikte bir ödül almak için Puzzles & Survival'ın resmi sitesinde yükleme yap. Her hesap başına yalnızca bir kez ödül talep edilebilir.
Dituntut

Günlük Giriş Ödülü
Oturum açmak için her gün etkinlik sayfasına giriş yap. Oturum ödüllerini talep etmek için 1/3/5/7 gün giriş yap.
"Her ödül katmanı, hesap başına yalnızca bir kez talep edilebilir."
Talep edilmeyen ödüllerin geçerliliği etkinlikten 7 gün sonra sona erer.
Ganhe fantásticas recompensas do Pacote Festival de Música!
"Etkinlik boyunca, Puzzles & Survival'ın resmi web sitesi aracılığıyla her gün yüklediğin her $19,99 sana bir Şans Bileti verecek."
Çekilişten rasgele ödüller almak için bir Şans Bileti kullan.
Her gün 100 adede kadar Şans Bilet elde edebilirsin.
"Şans Biletlerin her gün sıfırlanmayacak, ancak bunları etkinlik sona ermeden kullandığından emin ol."
Bonus Hediye
"İlgili ödüllerin kilidi, kullandığın toplam Şans Bileti sayısı belirli bir miktara ulaştığında açılacak."
Talep edilmeyen ödüllerin geçerliliği etkinlikten 7 gün sonra sona erer.
`,"copyTipsState":false,"previewPopup":``},"pl-PL":{"infoContent":`Prezent 1wszego doładowania
"Podczas wydarzenia doładuj konto na oficjalnej stronie Puzzles & Survival, aby otrzymać nagrodę. Nagroda może być odebrana tylko raz na jedno konto."
Nieodebrane nagrody wygasną 7 dni po zakończeniu wydarzenia.

Nagroda dziennego logowania
"Zaloguj się na stronie wydarzenia każdego dnia, aby zaliczyć dzienne logowanie. Zaloguj się przez 1/3/5/7 dni, aby odebrać nagrody za logowanie."
Każdy poziom nagród może być odebrany tylko raz na jedno konto.
Nieodebrane nagrody wygasną 7 dni po zakończeniu wydarzenia.
Luksusowe Pudełko Rocznicowe
"Podczas wydarzenia, każda kwota 19,99 USD, którą doładujesz codziennie za pośrednictwem oficjalnej strony Puzzles & Survival, przyzna Ci Szczęśliwy Bilet.
"
Użyj szczęśliwego biletu w losowaniu i otrzymaj losową nagrodę.
Codziennie możesz odebrać aż do 100 szczęśliwych biletów.
"Twoje szczęśliwe bilety nie będą resetowane każdego dnia, ale pamiętaj, aby użyć ich przed zakończeniem wydarzenia."
Prezent bonusu
"Odpowiednie nagrody zostaną odblokowane, gdy łączna liczba wykorzystanych przez Ciebie szczęśliwych biletów osiągnie określoną wartość."
Nieodebrane nagrody wygasną 7 dni po zakończeniu wydarzenia.
`,"copyTipsState":false,"previewPopup":``},"id-ID":{"infoContent":`1st Top-up Gift
During the event, top up on Puzzles & Survival's official website to obtain a reward. The reward can only be claimed once per account.
Unclaimed rewards will expire 7 days after the event ends.

Daily Sign-in Reward
Log in to the event page every day to sign in. Sign in for 1/3/5/7 day(s) to claim sign-in rewards.
Each tier of rewards can only be claimed once per account.
Unclaimed rewards will expire 7 days after the event ends.

Deluxe Anniversary Box
During the event, every $19.99 you top up every day via Puzzles & Survival's official website will grant you a Lucky Ticket.
Use a Lucky Ticket to draw once to get random rewards.
You can obtain up to 100 Lucky Tickets every day.
Your Lucky Tickets won't reset every day, but be sure to use them before the event ends.

Bonus Gift
Corresponding rewards will be unlocked when the total number of Lucky Tickets you used reaches a certain amount.
Unclaimed rewards will expire 7 days after the event ends.`,"copyTipsState":false,"previewPopup":``},"ar-SA":{"infoContent":`1st Top-up Gift
During the event, top up on Puzzles & Survival's official website to obtain a reward. The reward can only be claimed once per account.
Unclaimed rewards will expire 7 days after the event ends.

Daily Sign-in Reward
Log in to the event page every day to sign in. Sign in for 1/3/5/7 day(s) to claim sign-in rewards.
Each tier of rewards can only be claimed once per account.
Unclaimed rewards will expire 7 days after the event ends.

Deluxe Anniversary Box
During the event, every $19.99 you top up every day via Puzzles & Survival's official website will grant you a Lucky Ticket.
Use a Lucky Ticket to draw once to get random rewards.
You can obtain up to 100 Lucky Tickets every day.
Your Lucky Tickets won't reset every day, but be sure to use them before the event ends.

Bonus Gift
Corresponding rewards will be unlocked when the total number of Lucky Tickets you used reaches a certain amount.
Unclaimed rewards will expire 7 days after the event ends.`,"copyTipsState":false,"previewPopup":``}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '全局弹窗';

    // 自定义setup - 开始
    const { toClipboard } = useClipboard();

const showTips = inject("showTips", (txt, code) => {})
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})

const isIosAppWebview = window?.webkit?.messageHandlers?.callSDKMethodWithParameters;


const defaultServerItem = [
  { sid: "", id: "", sname: "" },
]
const defaultRoleItem = [{ roleID: "", roleName: getLangTxt("selectRole") }]
const curPlatform = pagePlatform;

const init = () => {
  compData.bindPopupState = false
  compData.bagPopupState = false
  compData.infoPopupState = false
  compData.tipsPopupState = false
  compData.propsPopupState = false
  compData.quanPopupState = false
  compData.seeGiftPopupState = false
  compData.giftCodePopupState = false
  compData.previewPopup = "";

  pageData.serverList = _.cloneDeep(defaultServerItem)
  pageData.roleList = _.cloneDeep(defaultRoleItem)


}

init()

watch(
  () => pageData.isLogin,
  async (value) => {
    if (!value) return
    await initServerList()
    initLinkServer()
  }
)

watch(
  () => pageData.serverItem,
  async (value) => {
    if (!value || !value.sid) return
    await initRoleList()
    initLinkRole()
  }
)

const initServerList = async () => {
  pageData.serverList = []
  const link = {
    global: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=listServerNew`,
    omnion: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=listServerNew`,
    gm99: `//eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=listServerNew`,
  }
  let res = await request.getJSON(link[curPlatform])
  if (res.result == 1) {
    res?.data?.all_servers
      ? pageData.serverList.push(...res.data.all_servers)
      : "";
    res?.data?.recent_servers
      ? pageData.recentServerList.push(...res.data.recent_servers)
      : "";
  }
}

const initRoleList = async () => {
  pageData.roleList = _.cloneDeep(defaultRoleItem)
  const link = {
    global: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=getMobileGameRole`,
    omnion: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=getMobileGameRole`,
    gm99: `//eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=getMobileGameRole`,
  }
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      server_id: pageData.serverItem.sid,
    }),
  })
  if (res.result == 1) {
    pageData.roleList.push(...res.data)
    if (res.data.length == 1) {
      pageData.roleIndex = 1
    }
  }
}

const initLinkServer = () => {
  let linkParam =
    utils.getUrlParams("serverId") ||
    utils.getUrlParams("server_id") ||
    utils.getUrlParams("serverID")
  let _index = 0
  for (let i in pageData.serverList) {
    if (pageData.serverList[i].id == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.serverItem = pageData.serverList[_index];
  }
}

const initLinkRole = () => {
  let linkParam =
    utils.getUrlParams("roleId") || utils.getUrlParams("roleID")
  let _index = 0
  for (let i in pageData.roleList) {
    if (pageData.roleList[i].roleID == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.roleIndex = _index
  }
}

const canClickBindSubmit = ref(true)
const bindRole = async () => {
  const link = {
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=bind`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=bind`,
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=bind`,
  }
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      server_id: pageData.serverItem.sid,
      server_sid: pageData.serverItem.id,
      role_id: pageData.roleList[pageData.roleIndex].roleID,
      role_name: encodeURIComponent(
        encodeURIComponent(pageData.roleList[pageData.roleIndex].roleName)
      ),
      server_name: pageData.serverItem.sname,
      language: curLang,
    }),
  })
  if (res.result == 1) {
    pageData.serverName = res.data.bind_data.server_name
    pageData.roleName = res.data.bind_data.role_name
    pageData.bindPopupState = false
    pageData.isBind = true
    try {
      window.__updatePointUploadCookie(
        "role_id",
        res.data.bind_data.role_id
      )
      window.__updatePointUploadCookie(
        "role_name",
        res.data.bind_data.role_name
      )
      window.__updatePointUploadCookie(
        "server_id",
        res.data.bind_data.server_id
      )
    } catch (error) {}
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
}

watch(()=>compData.copyTipsState,value=>{
  if(value){
    setTimeout(()=>{
      compData.copyTipsState = false;
    },2000)
  }
});
      // 绑定弹窗的click事件
      const u_c_I48K21_event_F8M123= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_1OB822_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认绑定的click事件
      const u_c_2UDV40_event_QSVC19= async (e)=>{
        try {if (!pageData.serverItem || !pageData.serverItem.sid) {
  alert(getLangTxt("selectServer"))
  return
}
if (!pageData.roleIndex) {
  alert(getLangTxt("selectRole"))
  return
}
if (!canClickBindSubmit.value) return
canClickBindSubmit.value = false
await bindRole()
canClickBindSubmit.value = true} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_IXTY43_event_DMX517= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗的click事件
      const u_c_J40V44_event_F8M123= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗内容的click事件
      const u_c_G90Y45_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 查看的click事件
      const u_c_YZRB62_event_1JVM17= async (e)=>{
        try {bridge.open(pageData.storeLink)} catch (error) {console.log(error)}
      };
      // 复制并前往的click事件
      const u_c_8QYO64_event_QX7K17= async (e,code)=>{
        try {try{
  await toClipboard(code);
}catch(e){}

bridge.openInline(pageData.exchangeLink)} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_GD8367_event_DMX517= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 提示语弹窗的click事件
      const u_c_JBXS68_event_TETB35= async (e)=>{
        try {pageData.tipsPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_FLPV69_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_AMGH72_event_V0IC67= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_EVGO74_event_DMX517= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 查看奖励弹窗的click事件
      const u_c_DSXT75_event_TETB35= async (e)=>{
        try {pageData.seeGiftPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_HPWW76_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_BRQF87_event_DMX517= async (e)=>{
        try {pageData.seeGiftPopupState = false} catch (error) {console.log(error)}
      };
      // 道具领取成功弹窗的click事件
      const u_c_EHPW88_event_TETB35= async (e)=>{
        try {pageData.propsPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_IOX689_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_6OXR96_event_YU9U68= async (e)=>{
        try {pageData.propsPopupState = false;} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_EM2I99_event_DMX517= async (e)=>{
        try {pageData.propsPopupState = false} catch (error) {console.log(error)}
      };
      // 优惠券领取成功弹窗的click事件
      const u_c_5R8F100_event_TETB35= async (e)=>{
        try {pageData.quanPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_2BKH101_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_BTH6108_event_35V252= async (e)=>{
        try {bridge.open(pageData.storeLink)} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_9BQD110_event_DMX517= async (e)=>{
        try {pageData.quanPopupState = false} catch (error) {console.log(error)}
      };
      // 序列号领取成功弹窗的click事件
      const u_c_2XPV111_event_TXZS38= async (e)=>{
        try {pageData.giftCodePopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_DB6Y112_event_EKU139= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 复制按钮的click事件
      const u_c_XYF6118_event_QX7K17= async (e)=>{
        try {await toClipboard(pageData.curGiftName);
compData.copyTipsState = true;} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_BSRV122_event_KBHJ41= async (e)=>{
        try {pageData.giftCodePopupState = false} catch (error) {console.log(error)}
      };
      // 前往兑换的click事件
      const u_c_F9TM123_event_YU9U68= async (e)=>{
        try {try{
  await toClipboard(pageData.curGiftName);
  compData.copyTipsState = true;
  await utils.sleep(1)
}catch(e){}

bridge.openInline(pageData.exchangeLink)} catch (error) {console.log(error)}
      };
      // 活动规则弹窗的click事件
      const u_c_GAB2125_event_TETB35= async (e)=>{
        try {pageData.infoPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_2FB6126_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_FFZT130_event_DMX517= async (e)=>{
        try {pageData.infoPopupState = false} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.default{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.default{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.default{
.u_c_CQKU26.normal{
position:relative;

}
}.default{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_EBOH36.normal{
position:relative;

}
}.default{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.default{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.default{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.default{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.default{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.default{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_ZVJ350.normal{
position:relative;

}
}.default{
.u_c_8WD951.normal{
position:relative;

}
}.default{
.u_c_ZT6B53.normal{
position:relative;

}
}.default{
.u_c_CW1R55.normal{
position:relative;

}
}.default{
.u_c_6SM956.normal{
position:relative;

}
}.default{
.u_c_DMOQ57.normal{
position:relative;

}
}.default{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.default{
.u_c_JC4161.normal{
position:relative;

}
}.default{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.default{
.u_c_8QYO64.normal{
position:relative;

}
}.default{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.default{
.u_c_JBXS68.normal{
position:relative;

}
}.default{
.u_c_FLPV69.normal{
position:relative;

}
}.default{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.default{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.default{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.default{
.u_c_DSXT75.normal{
position:relative;

}
}.default{
.u_c_HPWW76.normal{
position:relative;

}
}.default{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.default{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.default{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.default{
.u_c_98EV81.normal{
position:relative;

}
}.default{
.u_c_DJ6M82.normal{
position:relative;

}
}.default{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.default{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.default{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.default{
.u_c_08ZY86.normal{
position:relative;

}
}.default{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.default{
.u_c_EHPW88.normal{
position:relative;

}
}.default{
.u_c_IOX689.normal{
position:relative;

}
}.default{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.default{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.default{
.u_c_22F993.normal{
position:relative;

}
}.default{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.default{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.default{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.default{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.default{
.u_c_5R8F100.normal{
position:relative;

}
}.default{
.u_c_2BKH101.normal{
position:relative;

}
}.default{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.default{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.default{
.u_c_1MD4105.normal{
position:relative;

}
}.default{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.default{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.default{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.default{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_DB6Y112.normal{
position:relative;

}
}.default{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.default{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.default{
.u_c_2BKA116.normal{
position:relative;

}
}.default{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.default{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.default{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.default{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.default{
.u_c_GAB2125.normal{
position:relative;

}
}.default{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.default{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.zh-CN{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.zh-CN{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.zh-CN{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.zh-CN{
.u_c_CQKU26.normal{
position:relative;

}
}.zh-CN{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_EBOH36.normal{
position:relative;

}
}.zh-CN{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-CN{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.zh-CN{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.zh-CN{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.zh-CN{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.zh-CN{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.zh-CN{
.u_c_ZVJ350.normal{
position:relative;

}
}.zh-CN{
.u_c_8WD951.normal{
position:relative;

}
}.zh-CN{
.u_c_ZT6B53.normal{
position:relative;

}
}.zh-CN{
.u_c_CW1R55.normal{
position:relative;

}
}.zh-CN{
.u_c_6SM956.normal{
position:relative;

}
}.zh-CN{
.u_c_DMOQ57.normal{
position:relative;

}
}.zh-CN{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-CN{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.zh-CN{
.u_c_JC4161.normal{
position:relative;

}
}.zh-CN{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.zh-CN{
.u_c_8QYO64.normal{
position:relative;

}
}.zh-CN{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-CN{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.zh-CN{
.u_c_JBXS68.normal{
position:relative;

}
}.zh-CN{
.u_c_FLPV69.normal{
position:relative;

}
}.zh-CN{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.zh-CN{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-CN{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.zh-CN{
.u_c_DSXT75.normal{
position:relative;

}
}.zh-CN{
.u_c_HPWW76.normal{
position:relative;

}
}.zh-CN{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.zh-CN{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.zh-CN{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.zh-CN{
.u_c_98EV81.normal{
position:relative;

}
}.zh-CN{
.u_c_DJ6M82.normal{
position:relative;

}
}.zh-CN{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.zh-CN{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.zh-CN{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.zh-CN{
.u_c_08ZY86.normal{
position:relative;

}
}.zh-CN{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.zh-CN{
.u_c_EHPW88.normal{
position:relative;

}
}.zh-CN{
.u_c_IOX689.normal{
position:relative;

}
}.zh-CN{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.zh-CN{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.zh-CN{
.u_c_22F993.normal{
position:relative;

}
}.zh-CN{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.zh-CN{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.zh-CN{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-CN{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.zh-CN{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.zh-CN{
.u_c_5R8F100.normal{
position:relative;

}
}.zh-CN{
.u_c_2BKH101.normal{
position:relative;

}
}.zh-CN{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.zh-CN{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.zh-CN{
.u_c_1MD4105.normal{
position:relative;

}
}.zh-CN{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.zh-CN{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.zh-CN{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-CN{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.zh-CN{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_DB6Y112.normal{
position:relative;

}
}.zh-CN{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.zh-CN{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.zh-CN{
.u_c_2BKA116.normal{
position:relative;

}
}.zh-CN{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.zh-CN{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.zh-CN{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.zh-CN{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-CN{
.u_c_GAB2125.normal{
position:relative;

}
}.zh-CN{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.zh-CN{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-CN{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.zh-TW{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.zh-TW{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.zh-TW{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.zh-TW{
.u_c_CQKU26.normal{
position:relative;

}
}.zh-TW{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_EBOH36.normal{
position:relative;

}
}.zh-TW{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-TW{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.zh-TW{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.zh-TW{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.zh-TW{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.zh-TW{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.zh-TW{
.u_c_ZVJ350.normal{
position:relative;

}
}.zh-TW{
.u_c_8WD951.normal{
position:relative;

}
}.zh-TW{
.u_c_ZT6B53.normal{
position:relative;

}
}.zh-TW{
.u_c_CW1R55.normal{
position:relative;

}
}.zh-TW{
.u_c_6SM956.normal{
position:relative;

}
}.zh-TW{
.u_c_DMOQ57.normal{
position:relative;

}
}.zh-TW{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.zh-TW{
.u_c_JC4161.normal{
position:relative;

}
}.zh-TW{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.zh-TW{
.u_c_8QYO64.normal{
position:relative;

}
}.zh-TW{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-TW{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.zh-TW{
.u_c_JBXS68.normal{
position:relative;

}
}.zh-TW{
.u_c_FLPV69.normal{
position:relative;

}
}.zh-TW{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.zh-TW{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-TW{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.zh-TW{
.u_c_DSXT75.normal{
position:relative;

}
}.zh-TW{
.u_c_HPWW76.normal{
position:relative;

}
}.zh-TW{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.zh-TW{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.zh-TW{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.zh-TW{
.u_c_98EV81.normal{
position:relative;

}
}.zh-TW{
.u_c_DJ6M82.normal{
position:relative;

}
}.zh-TW{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.zh-TW{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.zh-TW{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.zh-TW{
.u_c_08ZY86.normal{
position:relative;

}
}.zh-TW{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.zh-TW{
.u_c_EHPW88.normal{
position:relative;

}
}.zh-TW{
.u_c_IOX689.normal{
position:relative;

}
}.zh-TW{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.zh-TW{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.zh-TW{
.u_c_22F993.normal{
position:relative;

}
}.zh-TW{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.zh-TW{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.zh-TW{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-TW{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.zh-TW{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.zh-TW{
.u_c_5R8F100.normal{
position:relative;

}
}.zh-TW{
.u_c_2BKH101.normal{
position:relative;

}
}.zh-TW{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.zh-TW{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.zh-TW{
.u_c_1MD4105.normal{
position:relative;

}
}.zh-TW{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.zh-TW{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.zh-TW{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-TW{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.zh-TW{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_DB6Y112.normal{
position:relative;

}
}.zh-TW{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.zh-TW{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.zh-TW{
.u_c_2BKA116.normal{
position:relative;

}
}.zh-TW{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.zh-TW{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.zh-TW{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.zh-TW{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-TW{
.u_c_GAB2125.normal{
position:relative;

}
}.zh-TW{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.zh-TW{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.en-US{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.en-US{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.en-US{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.en-US{
.u_c_CQKU26.normal{
position:relative;

}
}.en-US{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_EBOH36.normal{
position:relative;

}
}.en-US{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.en-US{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.en-US{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.en-US{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.en-US{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.en-US{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.en-US{
.u_c_ZVJ350.normal{
position:relative;

}
}.en-US{
.u_c_8WD951.normal{
position:relative;

}
}.en-US{
.u_c_ZT6B53.normal{
position:relative;

}
}.en-US{
.u_c_CW1R55.normal{
position:relative;

}
}.en-US{
.u_c_6SM956.normal{
position:relative;

}
}.en-US{
.u_c_DMOQ57.normal{
position:relative;

}
}.en-US{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.en-US{
.u_c_JC4161.normal{
position:relative;

}
}.en-US{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.en-US{
.u_c_8QYO64.normal{
position:relative;

}
}.en-US{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.en-US{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.en-US{
.u_c_JBXS68.normal{
position:relative;

}
}.en-US{
.u_c_FLPV69.normal{
position:relative;

}
}.en-US{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.en-US{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.en-US{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.en-US{
.u_c_DSXT75.normal{
position:relative;

}
}.en-US{
.u_c_HPWW76.normal{
position:relative;

}
}.en-US{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.en-US{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.en-US{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.en-US{
.u_c_98EV81.normal{
position:relative;

}
}.en-US{
.u_c_DJ6M82.normal{
position:relative;

}
}.en-US{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.en-US{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.en-US{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.en-US{
.u_c_08ZY86.normal{
position:relative;

}
}.en-US{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.en-US{
.u_c_EHPW88.normal{
position:relative;

}
}.en-US{
.u_c_IOX689.normal{
position:relative;

}
}.en-US{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.en-US{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.en-US{
.u_c_22F993.normal{
position:relative;

}
}.en-US{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.en-US{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.en-US{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.en-US{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.en-US{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.en-US{
.u_c_5R8F100.normal{
position:relative;

}
}.en-US{
.u_c_2BKH101.normal{
position:relative;

}
}.en-US{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.en-US{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.en-US{
.u_c_1MD4105.normal{
position:relative;

}
}.en-US{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.en-US{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.en-US{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.en-US{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.en-US{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_DB6Y112.normal{
position:relative;

}
}.en-US{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.en-US{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.en-US{
.u_c_2BKA116.normal{
position:relative;

}
}.en-US{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.en-US{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.en-US{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.en-US{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.en-US{
.u_c_GAB2125.normal{
position:relative;

}
}.en-US{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.en-US{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.en-US{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.ja-JP{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.ja-JP{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.ja-JP{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.ja-JP{
.u_c_CQKU26.normal{
position:relative;

}
}.ja-JP{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_EBOH36.normal{
position:relative;

}
}.ja-JP{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ja-JP{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.ja-JP{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.ja-JP{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.ja-JP{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.ja-JP{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.ja-JP{
.u_c_ZVJ350.normal{
position:relative;

}
}.ja-JP{
.u_c_8WD951.normal{
position:relative;

}
}.ja-JP{
.u_c_ZT6B53.normal{
position:relative;

}
}.ja-JP{
.u_c_CW1R55.normal{
position:relative;

}
}.ja-JP{
.u_c_6SM956.normal{
position:relative;

}
}.ja-JP{
.u_c_DMOQ57.normal{
position:relative;

}
}.ja-JP{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ja-JP{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.ja-JP{
.u_c_JC4161.normal{
position:relative;

}
}.ja-JP{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.ja-JP{
.u_c_8QYO64.normal{
position:relative;

}
}.ja-JP{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ja-JP{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ja-JP{
.u_c_JBXS68.normal{
position:relative;

}
}.ja-JP{
.u_c_FLPV69.normal{
position:relative;

}
}.ja-JP{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.ja-JP{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ja-JP{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.ja-JP{
.u_c_DSXT75.normal{
position:relative;

}
}.ja-JP{
.u_c_HPWW76.normal{
position:relative;

}
}.ja-JP{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.ja-JP{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.ja-JP{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.ja-JP{
.u_c_98EV81.normal{
position:relative;

}
}.ja-JP{
.u_c_DJ6M82.normal{
position:relative;

}
}.ja-JP{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.ja-JP{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.ja-JP{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.ja-JP{
.u_c_08ZY86.normal{
position:relative;

}
}.ja-JP{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.ja-JP{
.u_c_EHPW88.normal{
position:relative;

}
}.ja-JP{
.u_c_IOX689.normal{
position:relative;

}
}.ja-JP{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.ja-JP{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.ja-JP{
.u_c_22F993.normal{
position:relative;

}
}.ja-JP{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ja-JP{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ja-JP{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ja-JP{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.ja-JP{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.ja-JP{
.u_c_5R8F100.normal{
position:relative;

}
}.ja-JP{
.u_c_2BKH101.normal{
position:relative;

}
}.ja-JP{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.ja-JP{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.ja-JP{
.u_c_1MD4105.normal{
position:relative;

}
}.ja-JP{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ja-JP{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ja-JP{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ja-JP{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.ja-JP{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_DB6Y112.normal{
position:relative;

}
}.ja-JP{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.ja-JP{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.ja-JP{
.u_c_2BKA116.normal{
position:relative;

}
}.ja-JP{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.ja-JP{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.ja-JP{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.ja-JP{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ja-JP{
.u_c_GAB2125.normal{
position:relative;

}
}.ja-JP{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.ja-JP{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.ja-JP{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.ko-KR{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.ko-KR{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.ko-KR{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.ko-KR{
.u_c_CQKU26.normal{
position:relative;

}
}.ko-KR{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_EBOH36.normal{
position:relative;

}
}.ko-KR{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ko-KR{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.ko-KR{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.ko-KR{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.ko-KR{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.ko-KR{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.ko-KR{
.u_c_ZVJ350.normal{
position:relative;

}
}.ko-KR{
.u_c_8WD951.normal{
position:relative;

}
}.ko-KR{
.u_c_ZT6B53.normal{
position:relative;

}
}.ko-KR{
.u_c_CW1R55.normal{
position:relative;

}
}.ko-KR{
.u_c_6SM956.normal{
position:relative;

}
}.ko-KR{
.u_c_DMOQ57.normal{
position:relative;

}
}.ko-KR{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ko-KR{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.ko-KR{
.u_c_JC4161.normal{
position:relative;

}
}.ko-KR{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.ko-KR{
.u_c_8QYO64.normal{
position:relative;

}
}.ko-KR{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ko-KR{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ko-KR{
.u_c_JBXS68.normal{
position:relative;

}
}.ko-KR{
.u_c_FLPV69.normal{
position:relative;

}
}.ko-KR{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.ko-KR{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ko-KR{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.ko-KR{
.u_c_DSXT75.normal{
position:relative;

}
}.ko-KR{
.u_c_HPWW76.normal{
position:relative;

}
}.ko-KR{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.ko-KR{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.ko-KR{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.ko-KR{
.u_c_98EV81.normal{
position:relative;

}
}.ko-KR{
.u_c_DJ6M82.normal{
position:relative;

}
}.ko-KR{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.ko-KR{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.ko-KR{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.ko-KR{
.u_c_08ZY86.normal{
position:relative;

}
}.ko-KR{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.ko-KR{
.u_c_EHPW88.normal{
position:relative;

}
}.ko-KR{
.u_c_IOX689.normal{
position:relative;

}
}.ko-KR{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.ko-KR{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.ko-KR{
.u_c_22F993.normal{
position:relative;

}
}.ko-KR{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ko-KR{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ko-KR{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ko-KR{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.ko-KR{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.ko-KR{
.u_c_5R8F100.normal{
position:relative;

}
}.ko-KR{
.u_c_2BKH101.normal{
position:relative;

}
}.ko-KR{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.ko-KR{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.ko-KR{
.u_c_1MD4105.normal{
position:relative;

}
}.ko-KR{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ko-KR{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ko-KR{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ko-KR{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.ko-KR{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_DB6Y112.normal{
position:relative;

}
}.ko-KR{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.ko-KR{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.ko-KR{
.u_c_2BKA116.normal{
position:relative;

}
}.ko-KR{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.ko-KR{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.ko-KR{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.ko-KR{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ko-KR{
.u_c_GAB2125.normal{
position:relative;

}
}.ko-KR{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.ko-KR{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.ko-KR{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.th-TH{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.th-TH{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.th-TH{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.th-TH{
.u_c_CQKU26.normal{
position:relative;

}
}.th-TH{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_EBOH36.normal{
position:relative;

}
}.th-TH{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.th-TH{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.th-TH{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.th-TH{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.th-TH{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.th-TH{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.th-TH{
.u_c_ZVJ350.normal{
position:relative;

}
}.th-TH{
.u_c_8WD951.normal{
position:relative;

}
}.th-TH{
.u_c_ZT6B53.normal{
position:relative;

}
}.th-TH{
.u_c_CW1R55.normal{
position:relative;

}
}.th-TH{
.u_c_6SM956.normal{
position:relative;

}
}.th-TH{
.u_c_DMOQ57.normal{
position:relative;

}
}.th-TH{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.th-TH{
.u_c_JC4161.normal{
position:relative;

}
}.th-TH{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.th-TH{
.u_c_8QYO64.normal{
position:relative;

}
}.th-TH{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.th-TH{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.th-TH{
.u_c_JBXS68.normal{
position:relative;

}
}.th-TH{
.u_c_FLPV69.normal{
position:relative;

}
}.th-TH{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.th-TH{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.th-TH{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.th-TH{
.u_c_DSXT75.normal{
position:relative;

}
}.th-TH{
.u_c_HPWW76.normal{
position:relative;

}
}.th-TH{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.th-TH{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.th-TH{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.th-TH{
.u_c_98EV81.normal{
position:relative;

}
}.th-TH{
.u_c_DJ6M82.normal{
position:relative;

}
}.th-TH{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.th-TH{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.th-TH{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.th-TH{
.u_c_08ZY86.normal{
position:relative;

}
}.th-TH{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.th-TH{
.u_c_EHPW88.normal{
position:relative;

}
}.th-TH{
.u_c_IOX689.normal{
position:relative;

}
}.th-TH{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.th-TH{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.th-TH{
.u_c_22F993.normal{
position:relative;

}
}.th-TH{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.th-TH{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.th-TH{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.th-TH{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.th-TH{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.th-TH{
.u_c_5R8F100.normal{
position:relative;

}
}.th-TH{
.u_c_2BKH101.normal{
position:relative;

}
}.th-TH{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.th-TH{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.th-TH{
.u_c_1MD4105.normal{
position:relative;

}
}.th-TH{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.th-TH{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.th-TH{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.th-TH{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.th-TH{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_DB6Y112.normal{
position:relative;

}
}.th-TH{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.th-TH{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.th-TH{
.u_c_2BKA116.normal{
position:relative;

}
}.th-TH{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.th-TH{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.th-TH{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.th-TH{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.th-TH{
.u_c_GAB2125.normal{
position:relative;

}
}.th-TH{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.th-TH{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.th-TH{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.vi-VN{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.vi-VN{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.vi-VN{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.vi-VN{
.u_c_CQKU26.normal{
position:relative;

}
}.vi-VN{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_EBOH36.normal{
position:relative;

}
}.vi-VN{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.vi-VN{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.vi-VN{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.vi-VN{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.vi-VN{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.vi-VN{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.vi-VN{
.u_c_ZVJ350.normal{
position:relative;

}
}.vi-VN{
.u_c_8WD951.normal{
position:relative;

}
}.vi-VN{
.u_c_ZT6B53.normal{
position:relative;

}
}.vi-VN{
.u_c_CW1R55.normal{
position:relative;

}
}.vi-VN{
.u_c_6SM956.normal{
position:relative;

}
}.vi-VN{
.u_c_DMOQ57.normal{
position:relative;

}
}.vi-VN{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.vi-VN{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.vi-VN{
.u_c_JC4161.normal{
position:relative;

}
}.vi-VN{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.vi-VN{
.u_c_8QYO64.normal{
position:relative;

}
}.vi-VN{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.vi-VN{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.vi-VN{
.u_c_JBXS68.normal{
position:relative;

}
}.vi-VN{
.u_c_FLPV69.normal{
position:relative;

}
}.vi-VN{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.vi-VN{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.vi-VN{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.vi-VN{
.u_c_DSXT75.normal{
position:relative;

}
}.vi-VN{
.u_c_HPWW76.normal{
position:relative;

}
}.vi-VN{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.vi-VN{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.vi-VN{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.vi-VN{
.u_c_98EV81.normal{
position:relative;

}
}.vi-VN{
.u_c_DJ6M82.normal{
position:relative;

}
}.vi-VN{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.vi-VN{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.vi-VN{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.vi-VN{
.u_c_08ZY86.normal{
position:relative;

}
}.vi-VN{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.vi-VN{
.u_c_EHPW88.normal{
position:relative;

}
}.vi-VN{
.u_c_IOX689.normal{
position:relative;

}
}.vi-VN{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.vi-VN{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.vi-VN{
.u_c_22F993.normal{
position:relative;

}
}.vi-VN{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.vi-VN{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.vi-VN{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.vi-VN{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.vi-VN{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.vi-VN{
.u_c_5R8F100.normal{
position:relative;

}
}.vi-VN{
.u_c_2BKH101.normal{
position:relative;

}
}.vi-VN{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.vi-VN{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.vi-VN{
.u_c_1MD4105.normal{
position:relative;

}
}.vi-VN{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.vi-VN{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.vi-VN{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.vi-VN{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.vi-VN{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_DB6Y112.normal{
position:relative;

}
}.vi-VN{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.vi-VN{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.vi-VN{
.u_c_2BKA116.normal{
position:relative;

}
}.vi-VN{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.vi-VN{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.vi-VN{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.vi-VN{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.vi-VN{
.u_c_GAB2125.normal{
position:relative;

}
}.vi-VN{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.vi-VN{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.vi-VN{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.de-DE{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.de-DE{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.de-DE{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.de-DE{
.u_c_CQKU26.normal{
position:relative;

}
}.de-DE{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_EBOH36.normal{
position:relative;

}
}.de-DE{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.de-DE{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.de-DE{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.de-DE{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.de-DE{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.de-DE{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.de-DE{
.u_c_ZVJ350.normal{
position:relative;

}
}.de-DE{
.u_c_8WD951.normal{
position:relative;

}
}.de-DE{
.u_c_ZT6B53.normal{
position:relative;

}
}.de-DE{
.u_c_CW1R55.normal{
position:relative;

}
}.de-DE{
.u_c_6SM956.normal{
position:relative;

}
}.de-DE{
.u_c_DMOQ57.normal{
position:relative;

}
}.de-DE{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.de-DE{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.de-DE{
.u_c_JC4161.normal{
position:relative;

}
}.de-DE{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.de-DE{
.u_c_8QYO64.normal{
position:relative;

}
}.de-DE{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.de-DE{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.de-DE{
.u_c_JBXS68.normal{
position:relative;

}
}.de-DE{
.u_c_FLPV69.normal{
position:relative;

}
}.de-DE{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.de-DE{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.de-DE{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.de-DE{
.u_c_DSXT75.normal{
position:relative;

}
}.de-DE{
.u_c_HPWW76.normal{
position:relative;

}
}.de-DE{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.de-DE{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.de-DE{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.de-DE{
.u_c_98EV81.normal{
position:relative;

}
}.de-DE{
.u_c_DJ6M82.normal{
position:relative;

}
}.de-DE{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.de-DE{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.de-DE{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.de-DE{
.u_c_08ZY86.normal{
position:relative;

}
}.de-DE{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.de-DE{
.u_c_EHPW88.normal{
position:relative;

}
}.de-DE{
.u_c_IOX689.normal{
position:relative;

}
}.de-DE{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.de-DE{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.de-DE{
.u_c_22F993.normal{
position:relative;

}
}.de-DE{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.de-DE{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.de-DE{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.de-DE{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.de-DE{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.de-DE{
.u_c_5R8F100.normal{
position:relative;

}
}.de-DE{
.u_c_2BKH101.normal{
position:relative;

}
}.de-DE{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.de-DE{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.de-DE{
.u_c_1MD4105.normal{
position:relative;

}
}.de-DE{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.de-DE{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.de-DE{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.de-DE{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.de-DE{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_DB6Y112.normal{
position:relative;

}
}.de-DE{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.de-DE{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.de-DE{
.u_c_2BKA116.normal{
position:relative;

}
}.de-DE{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.de-DE{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.de-DE{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.de-DE{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.de-DE{
.u_c_GAB2125.normal{
position:relative;

}
}.de-DE{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.de-DE{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.de-DE{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.fr-FR{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.fr-FR{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.fr-FR{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.fr-FR{
.u_c_CQKU26.normal{
position:relative;

}
}.fr-FR{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_EBOH36.normal{
position:relative;

}
}.fr-FR{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.fr-FR{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.fr-FR{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.fr-FR{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.fr-FR{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.fr-FR{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.fr-FR{
.u_c_ZVJ350.normal{
position:relative;

}
}.fr-FR{
.u_c_8WD951.normal{
position:relative;

}
}.fr-FR{
.u_c_ZT6B53.normal{
position:relative;

}
}.fr-FR{
.u_c_CW1R55.normal{
position:relative;

}
}.fr-FR{
.u_c_6SM956.normal{
position:relative;

}
}.fr-FR{
.u_c_DMOQ57.normal{
position:relative;

}
}.fr-FR{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.fr-FR{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.fr-FR{
.u_c_JC4161.normal{
position:relative;

}
}.fr-FR{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.fr-FR{
.u_c_8QYO64.normal{
position:relative;

}
}.fr-FR{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.fr-FR{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.fr-FR{
.u_c_JBXS68.normal{
position:relative;

}
}.fr-FR{
.u_c_FLPV69.normal{
position:relative;

}
}.fr-FR{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.fr-FR{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.fr-FR{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.fr-FR{
.u_c_DSXT75.normal{
position:relative;

}
}.fr-FR{
.u_c_HPWW76.normal{
position:relative;

}
}.fr-FR{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.fr-FR{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.fr-FR{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.fr-FR{
.u_c_98EV81.normal{
position:relative;

}
}.fr-FR{
.u_c_DJ6M82.normal{
position:relative;

}
}.fr-FR{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.fr-FR{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.fr-FR{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.fr-FR{
.u_c_08ZY86.normal{
position:relative;

}
}.fr-FR{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.fr-FR{
.u_c_EHPW88.normal{
position:relative;

}
}.fr-FR{
.u_c_IOX689.normal{
position:relative;

}
}.fr-FR{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.fr-FR{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.fr-FR{
.u_c_22F993.normal{
position:relative;

}
}.fr-FR{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.fr-FR{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.fr-FR{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.fr-FR{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.fr-FR{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.fr-FR{
.u_c_5R8F100.normal{
position:relative;

}
}.fr-FR{
.u_c_2BKH101.normal{
position:relative;

}
}.fr-FR{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.fr-FR{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.fr-FR{
.u_c_1MD4105.normal{
position:relative;

}
}.fr-FR{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.fr-FR{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.fr-FR{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.fr-FR{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.fr-FR{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_DB6Y112.normal{
position:relative;

}
}.fr-FR{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.fr-FR{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.fr-FR{
.u_c_2BKA116.normal{
position:relative;

}
}.fr-FR{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.fr-FR{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.fr-FR{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.fr-FR{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.fr-FR{
.u_c_GAB2125.normal{
position:relative;

}
}.fr-FR{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.fr-FR{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.fr-FR{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.ru-RU{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.ru-RU{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.ru-RU{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.ru-RU{
.u_c_CQKU26.normal{
position:relative;

}
}.ru-RU{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_EBOH36.normal{
position:relative;

}
}.ru-RU{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ru-RU{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.ru-RU{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.ru-RU{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.ru-RU{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.ru-RU{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.ru-RU{
.u_c_ZVJ350.normal{
position:relative;

}
}.ru-RU{
.u_c_8WD951.normal{
position:relative;

}
}.ru-RU{
.u_c_ZT6B53.normal{
position:relative;

}
}.ru-RU{
.u_c_CW1R55.normal{
position:relative;

}
}.ru-RU{
.u_c_6SM956.normal{
position:relative;

}
}.ru-RU{
.u_c_DMOQ57.normal{
position:relative;

}
}.ru-RU{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.ru-RU{
.u_c_JC4161.normal{
position:relative;

}
}.ru-RU{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.ru-RU{
.u_c_8QYO64.normal{
position:relative;

}
}.ru-RU{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ru-RU{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ru-RU{
.u_c_JBXS68.normal{
position:relative;

}
}.ru-RU{
.u_c_FLPV69.normal{
position:relative;

}
}.ru-RU{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.ru-RU{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ru-RU{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.ru-RU{
.u_c_DSXT75.normal{
position:relative;

}
}.ru-RU{
.u_c_HPWW76.normal{
position:relative;

}
}.ru-RU{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.ru-RU{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.ru-RU{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.ru-RU{
.u_c_98EV81.normal{
position:relative;

}
}.ru-RU{
.u_c_DJ6M82.normal{
position:relative;

}
}.ru-RU{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.ru-RU{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.ru-RU{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.ru-RU{
.u_c_08ZY86.normal{
position:relative;

}
}.ru-RU{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.ru-RU{
.u_c_EHPW88.normal{
position:relative;

}
}.ru-RU{
.u_c_IOX689.normal{
position:relative;

}
}.ru-RU{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.ru-RU{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.ru-RU{
.u_c_22F993.normal{
position:relative;

}
}.ru-RU{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ru-RU{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ru-RU{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ru-RU{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.ru-RU{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.ru-RU{
.u_c_5R8F100.normal{
position:relative;

}
}.ru-RU{
.u_c_2BKH101.normal{
position:relative;

}
}.ru-RU{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.ru-RU{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.ru-RU{
.u_c_1MD4105.normal{
position:relative;

}
}.ru-RU{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ru-RU{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ru-RU{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ru-RU{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.ru-RU{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_DB6Y112.normal{
position:relative;

}
}.ru-RU{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.ru-RU{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.ru-RU{
.u_c_2BKA116.normal{
position:relative;

}
}.ru-RU{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.ru-RU{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.ru-RU{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.ru-RU{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ru-RU{
.u_c_GAB2125.normal{
position:relative;

}
}.ru-RU{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.ru-RU{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.ru-RU{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.es-ES{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.es-ES{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.es-ES{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.es-ES{
.u_c_CQKU26.normal{
position:relative;

}
}.es-ES{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_EBOH36.normal{
position:relative;

}
}.es-ES{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.es-ES{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.es-ES{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.es-ES{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.es-ES{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.es-ES{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.es-ES{
.u_c_ZVJ350.normal{
position:relative;

}
}.es-ES{
.u_c_8WD951.normal{
position:relative;

}
}.es-ES{
.u_c_ZT6B53.normal{
position:relative;

}
}.es-ES{
.u_c_CW1R55.normal{
position:relative;

}
}.es-ES{
.u_c_6SM956.normal{
position:relative;

}
}.es-ES{
.u_c_DMOQ57.normal{
position:relative;

}
}.es-ES{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.es-ES{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.es-ES{
.u_c_JC4161.normal{
position:relative;

}
}.es-ES{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.es-ES{
.u_c_8QYO64.normal{
position:relative;

}
}.es-ES{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.es-ES{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.es-ES{
.u_c_JBXS68.normal{
position:relative;

}
}.es-ES{
.u_c_FLPV69.normal{
position:relative;

}
}.es-ES{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.es-ES{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.es-ES{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.es-ES{
.u_c_DSXT75.normal{
position:relative;

}
}.es-ES{
.u_c_HPWW76.normal{
position:relative;

}
}.es-ES{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.es-ES{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.es-ES{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.es-ES{
.u_c_98EV81.normal{
position:relative;

}
}.es-ES{
.u_c_DJ6M82.normal{
position:relative;

}
}.es-ES{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.es-ES{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.es-ES{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.es-ES{
.u_c_08ZY86.normal{
position:relative;

}
}.es-ES{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.es-ES{
.u_c_EHPW88.normal{
position:relative;

}
}.es-ES{
.u_c_IOX689.normal{
position:relative;

}
}.es-ES{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.es-ES{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.es-ES{
.u_c_22F993.normal{
position:relative;

}
}.es-ES{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.es-ES{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.es-ES{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.es-ES{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.es-ES{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.es-ES{
.u_c_5R8F100.normal{
position:relative;

}
}.es-ES{
.u_c_2BKH101.normal{
position:relative;

}
}.es-ES{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.es-ES{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.es-ES{
.u_c_1MD4105.normal{
position:relative;

}
}.es-ES{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.es-ES{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.es-ES{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.es-ES{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.es-ES{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_DB6Y112.normal{
position:relative;

}
}.es-ES{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.es-ES{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.es-ES{
.u_c_2BKA116.normal{
position:relative;

}
}.es-ES{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.es-ES{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.es-ES{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.es-ES{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.es-ES{
.u_c_GAB2125.normal{
position:relative;

}
}.es-ES{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.es-ES{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.es-ES{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.pt-PT{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.pt-PT{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.pt-PT{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.pt-PT{
.u_c_CQKU26.normal{
position:relative;

}
}.pt-PT{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_EBOH36.normal{
position:relative;

}
}.pt-PT{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pt-PT{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.pt-PT{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.pt-PT{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.pt-PT{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.pt-PT{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.pt-PT{
.u_c_ZVJ350.normal{
position:relative;

}
}.pt-PT{
.u_c_8WD951.normal{
position:relative;

}
}.pt-PT{
.u_c_ZT6B53.normal{
position:relative;

}
}.pt-PT{
.u_c_CW1R55.normal{
position:relative;

}
}.pt-PT{
.u_c_6SM956.normal{
position:relative;

}
}.pt-PT{
.u_c_DMOQ57.normal{
position:relative;

}
}.pt-PT{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.pt-PT{
.u_c_JC4161.normal{
position:relative;

}
}.pt-PT{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.pt-PT{
.u_c_8QYO64.normal{
position:relative;

}
}.pt-PT{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pt-PT{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.pt-PT{
.u_c_JBXS68.normal{
position:relative;

}
}.pt-PT{
.u_c_FLPV69.normal{
position:relative;

}
}.pt-PT{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.pt-PT{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pt-PT{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.pt-PT{
.u_c_DSXT75.normal{
position:relative;

}
}.pt-PT{
.u_c_HPWW76.normal{
position:relative;

}
}.pt-PT{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.pt-PT{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.pt-PT{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.pt-PT{
.u_c_98EV81.normal{
position:relative;

}
}.pt-PT{
.u_c_DJ6M82.normal{
position:relative;

}
}.pt-PT{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.pt-PT{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.pt-PT{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.pt-PT{
.u_c_08ZY86.normal{
position:relative;

}
}.pt-PT{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.pt-PT{
.u_c_EHPW88.normal{
position:relative;

}
}.pt-PT{
.u_c_IOX689.normal{
position:relative;

}
}.pt-PT{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.pt-PT{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.pt-PT{
.u_c_22F993.normal{
position:relative;

}
}.pt-PT{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.pt-PT{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.pt-PT{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pt-PT{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.pt-PT{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.pt-PT{
.u_c_5R8F100.normal{
position:relative;

}
}.pt-PT{
.u_c_2BKH101.normal{
position:relative;

}
}.pt-PT{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.pt-PT{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.pt-PT{
.u_c_1MD4105.normal{
position:relative;

}
}.pt-PT{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.pt-PT{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.pt-PT{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pt-PT{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.pt-PT{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_DB6Y112.normal{
position:relative;

}
}.pt-PT{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.pt-PT{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.pt-PT{
.u_c_2BKA116.normal{
position:relative;

}
}.pt-PT{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.pt-PT{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.pt-PT{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.pt-PT{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pt-PT{
.u_c_GAB2125.normal{
position:relative;

}
}.pt-PT{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.pt-PT{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.pt-PT{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.it-IT{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.it-IT{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.it-IT{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.it-IT{
.u_c_CQKU26.normal{
position:relative;

}
}.it-IT{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_EBOH36.normal{
position:relative;

}
}.it-IT{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.it-IT{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.it-IT{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.it-IT{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.it-IT{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.it-IT{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.it-IT{
.u_c_ZVJ350.normal{
position:relative;

}
}.it-IT{
.u_c_8WD951.normal{
position:relative;

}
}.it-IT{
.u_c_ZT6B53.normal{
position:relative;

}
}.it-IT{
.u_c_CW1R55.normal{
position:relative;

}
}.it-IT{
.u_c_6SM956.normal{
position:relative;

}
}.it-IT{
.u_c_DMOQ57.normal{
position:relative;

}
}.it-IT{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.it-IT{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.it-IT{
.u_c_JC4161.normal{
position:relative;

}
}.it-IT{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.it-IT{
.u_c_8QYO64.normal{
position:relative;

}
}.it-IT{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.it-IT{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.it-IT{
.u_c_JBXS68.normal{
position:relative;

}
}.it-IT{
.u_c_FLPV69.normal{
position:relative;

}
}.it-IT{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.it-IT{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.it-IT{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.it-IT{
.u_c_DSXT75.normal{
position:relative;

}
}.it-IT{
.u_c_HPWW76.normal{
position:relative;

}
}.it-IT{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.it-IT{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.it-IT{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.it-IT{
.u_c_98EV81.normal{
position:relative;

}
}.it-IT{
.u_c_DJ6M82.normal{
position:relative;

}
}.it-IT{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.it-IT{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.it-IT{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.it-IT{
.u_c_08ZY86.normal{
position:relative;

}
}.it-IT{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.it-IT{
.u_c_EHPW88.normal{
position:relative;

}
}.it-IT{
.u_c_IOX689.normal{
position:relative;

}
}.it-IT{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.it-IT{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.it-IT{
.u_c_22F993.normal{
position:relative;

}
}.it-IT{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.it-IT{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.it-IT{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.it-IT{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.it-IT{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.it-IT{
.u_c_5R8F100.normal{
position:relative;

}
}.it-IT{
.u_c_2BKH101.normal{
position:relative;

}
}.it-IT{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.it-IT{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.it-IT{
.u_c_1MD4105.normal{
position:relative;

}
}.it-IT{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.it-IT{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.it-IT{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.it-IT{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.it-IT{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_DB6Y112.normal{
position:relative;

}
}.it-IT{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.it-IT{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.it-IT{
.u_c_2BKA116.normal{
position:relative;

}
}.it-IT{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.it-IT{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.it-IT{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.it-IT{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.it-IT{
.u_c_GAB2125.normal{
position:relative;

}
}.it-IT{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.it-IT{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.it-IT{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.tr-TR{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.tr-TR{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.tr-TR{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.tr-TR{
.u_c_CQKU26.normal{
position:relative;

}
}.tr-TR{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_EBOH36.normal{
position:relative;

}
}.tr-TR{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.tr-TR{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.tr-TR{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.tr-TR{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.tr-TR{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.tr-TR{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.tr-TR{
.u_c_ZVJ350.normal{
position:relative;

}
}.tr-TR{
.u_c_8WD951.normal{
position:relative;

}
}.tr-TR{
.u_c_ZT6B53.normal{
position:relative;

}
}.tr-TR{
.u_c_CW1R55.normal{
position:relative;

}
}.tr-TR{
.u_c_6SM956.normal{
position:relative;

}
}.tr-TR{
.u_c_DMOQ57.normal{
position:relative;

}
}.tr-TR{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.tr-TR{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.tr-TR{
.u_c_JC4161.normal{
position:relative;

}
}.tr-TR{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.tr-TR{
.u_c_8QYO64.normal{
position:relative;

}
}.tr-TR{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.tr-TR{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.tr-TR{
.u_c_JBXS68.normal{
position:relative;

}
}.tr-TR{
.u_c_FLPV69.normal{
position:relative;

}
}.tr-TR{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.tr-TR{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.tr-TR{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.tr-TR{
.u_c_DSXT75.normal{
position:relative;

}
}.tr-TR{
.u_c_HPWW76.normal{
position:relative;

}
}.tr-TR{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.tr-TR{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.tr-TR{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.tr-TR{
.u_c_98EV81.normal{
position:relative;

}
}.tr-TR{
.u_c_DJ6M82.normal{
position:relative;

}
}.tr-TR{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.tr-TR{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.tr-TR{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.tr-TR{
.u_c_08ZY86.normal{
position:relative;

}
}.tr-TR{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.tr-TR{
.u_c_EHPW88.normal{
position:relative;

}
}.tr-TR{
.u_c_IOX689.normal{
position:relative;

}
}.tr-TR{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.tr-TR{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.tr-TR{
.u_c_22F993.normal{
position:relative;

}
}.tr-TR{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.tr-TR{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.tr-TR{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.tr-TR{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.tr-TR{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.tr-TR{
.u_c_5R8F100.normal{
position:relative;

}
}.tr-TR{
.u_c_2BKH101.normal{
position:relative;

}
}.tr-TR{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.tr-TR{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.tr-TR{
.u_c_1MD4105.normal{
position:relative;

}
}.tr-TR{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.tr-TR{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.tr-TR{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.tr-TR{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.tr-TR{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_DB6Y112.normal{
position:relative;

}
}.tr-TR{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.tr-TR{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.tr-TR{
.u_c_2BKA116.normal{
position:relative;

}
}.tr-TR{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.tr-TR{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.tr-TR{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.tr-TR{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.tr-TR{
.u_c_GAB2125.normal{
position:relative;

}
}.tr-TR{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.tr-TR{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.tr-TR{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.pl-PL{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.pl-PL{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.pl-PL{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.pl-PL{
.u_c_CQKU26.normal{
position:relative;

}
}.pl-PL{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_EBOH36.normal{
position:relative;

}
}.pl-PL{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pl-PL{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.pl-PL{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.pl-PL{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.pl-PL{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.pl-PL{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.pl-PL{
.u_c_ZVJ350.normal{
position:relative;

}
}.pl-PL{
.u_c_8WD951.normal{
position:relative;

}
}.pl-PL{
.u_c_ZT6B53.normal{
position:relative;

}
}.pl-PL{
.u_c_CW1R55.normal{
position:relative;

}
}.pl-PL{
.u_c_6SM956.normal{
position:relative;

}
}.pl-PL{
.u_c_DMOQ57.normal{
position:relative;

}
}.pl-PL{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pl-PL{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.pl-PL{
.u_c_JC4161.normal{
position:relative;

}
}.pl-PL{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.pl-PL{
.u_c_8QYO64.normal{
position:relative;

}
}.pl-PL{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pl-PL{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.pl-PL{
.u_c_JBXS68.normal{
position:relative;

}
}.pl-PL{
.u_c_FLPV69.normal{
position:relative;

}
}.pl-PL{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.pl-PL{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pl-PL{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.pl-PL{
.u_c_DSXT75.normal{
position:relative;

}
}.pl-PL{
.u_c_HPWW76.normal{
position:relative;

}
}.pl-PL{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.pl-PL{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.pl-PL{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.pl-PL{
.u_c_98EV81.normal{
position:relative;

}
}.pl-PL{
.u_c_DJ6M82.normal{
position:relative;

}
}.pl-PL{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.pl-PL{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.pl-PL{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.pl-PL{
.u_c_08ZY86.normal{
position:relative;

}
}.pl-PL{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.pl-PL{
.u_c_EHPW88.normal{
position:relative;

}
}.pl-PL{
.u_c_IOX689.normal{
position:relative;

}
}.pl-PL{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.pl-PL{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.pl-PL{
.u_c_22F993.normal{
position:relative;

}
}.pl-PL{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.pl-PL{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.pl-PL{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pl-PL{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.pl-PL{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.pl-PL{
.u_c_5R8F100.normal{
position:relative;

}
}.pl-PL{
.u_c_2BKH101.normal{
position:relative;

}
}.pl-PL{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.pl-PL{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.pl-PL{
.u_c_1MD4105.normal{
position:relative;

}
}.pl-PL{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.pl-PL{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.pl-PL{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pl-PL{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.pl-PL{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_DB6Y112.normal{
position:relative;

}
}.pl-PL{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.pl-PL{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.pl-PL{
.u_c_2BKA116.normal{
position:relative;

}
}.pl-PL{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.pl-PL{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.pl-PL{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.pl-PL{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pl-PL{
.u_c_GAB2125.normal{
position:relative;

}
}.pl-PL{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.pl-PL{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.pl-PL{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.id-ID{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.id-ID{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.id-ID{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.id-ID{
.u_c_CQKU26.normal{
position:relative;

}
}.id-ID{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_EBOH36.normal{
position:relative;

}
}.id-ID{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.id-ID{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.id-ID{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.id-ID{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.id-ID{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.id-ID{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.id-ID{
.u_c_ZVJ350.normal{
position:relative;

}
}.id-ID{
.u_c_8WD951.normal{
position:relative;

}
}.id-ID{
.u_c_ZT6B53.normal{
position:relative;

}
}.id-ID{
.u_c_CW1R55.normal{
position:relative;

}
}.id-ID{
.u_c_6SM956.normal{
position:relative;

}
}.id-ID{
.u_c_DMOQ57.normal{
position:relative;

}
}.id-ID{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.id-ID{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.id-ID{
.u_c_JC4161.normal{
position:relative;

}
}.id-ID{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.id-ID{
.u_c_8QYO64.normal{
position:relative;

}
}.id-ID{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.id-ID{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.id-ID{
.u_c_JBXS68.normal{
position:relative;

}
}.id-ID{
.u_c_FLPV69.normal{
position:relative;

}
}.id-ID{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.id-ID{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.id-ID{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.id-ID{
.u_c_DSXT75.normal{
position:relative;

}
}.id-ID{
.u_c_HPWW76.normal{
position:relative;

}
}.id-ID{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.id-ID{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.id-ID{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.id-ID{
.u_c_98EV81.normal{
position:relative;

}
}.id-ID{
.u_c_DJ6M82.normal{
position:relative;

}
}.id-ID{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.id-ID{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.id-ID{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.id-ID{
.u_c_08ZY86.normal{
position:relative;

}
}.id-ID{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.id-ID{
.u_c_EHPW88.normal{
position:relative;

}
}.id-ID{
.u_c_IOX689.normal{
position:relative;

}
}.id-ID{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.id-ID{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.id-ID{
.u_c_22F993.normal{
position:relative;

}
}.id-ID{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.id-ID{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.id-ID{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.id-ID{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.id-ID{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.id-ID{
.u_c_5R8F100.normal{
position:relative;

}
}.id-ID{
.u_c_2BKH101.normal{
position:relative;

}
}.id-ID{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.id-ID{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.id-ID{
.u_c_1MD4105.normal{
position:relative;

}
}.id-ID{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.id-ID{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.id-ID{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.id-ID{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.id-ID{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_DB6Y112.normal{
position:relative;

}
}.id-ID{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.id-ID{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.id-ID{
.u_c_2BKA116.normal{
position:relative;

}
}.id-ID{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.id-ID{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.id-ID{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.id-ID{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.id-ID{
.u_c_GAB2125.normal{
position:relative;

}
}.id-ID{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.id-ID{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.id-ID{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.ar-SA{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.31rem;
height:6.79rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264388-58.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.49rem;
height:0.48rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264396-29.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.31rem;
height:9.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004427-28.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:2.77rem;
height:0.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004449-94.png);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.ar-SA{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.ar-SA{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.ar-SA{
.u_c_CQKU26.normal{
position:relative;

}
}.ar-SA{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_EBOH36.normal{
position:relative;

}
}.ar-SA{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ar-SA{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.ar-SA{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.ar-SA{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.ar-SA{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.ar-SA{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.ar-SA{
.u_c_ZVJ350.normal{
position:relative;

}
}.ar-SA{
.u_c_8WD951.normal{
position:relative;

}
}.ar-SA{
.u_c_ZT6B53.normal{
position:relative;

}
}.ar-SA{
.u_c_CW1R55.normal{
position:relative;

}
}.ar-SA{
.u_c_6SM956.normal{
position:relative;

}
}.ar-SA{
.u_c_DMOQ57.normal{
position:relative;

}
}.ar-SA{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ar-SA{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.ar-SA{
.u_c_JC4161.normal{
position:relative;

}
}.ar-SA{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.ar-SA{
.u_c_8QYO64.normal{
position:relative;

}
}.ar-SA{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ar-SA{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ar-SA{
.u_c_JBXS68.normal{
position:relative;

}
}.ar-SA{
.u_c_FLPV69.normal{
position:relative;

}
}.ar-SA{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.ar-SA{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ar-SA{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.ar-SA{
.u_c_DSXT75.normal{
position:relative;

}
}.ar-SA{
.u_c_HPWW76.normal{
position:relative;

}
}.ar-SA{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.ar-SA{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.ar-SA{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.ar-SA{
.u_c_98EV81.normal{
position:relative;

}
}.ar-SA{
.u_c_DJ6M82.normal{
position:relative;

}
}.ar-SA{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.ar-SA{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.ar-SA{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.ar-SA{
.u_c_08ZY86.normal{
position:relative;

}
}.ar-SA{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.ar-SA{
.u_c_EHPW88.normal{
position:relative;

}
}.ar-SA{
.u_c_IOX689.normal{
position:relative;

}
}.ar-SA{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.ar-SA{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.ar-SA{
.u_c_22F993.normal{
position:relative;

}
}.ar-SA{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ar-SA{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ar-SA{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ar-SA{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.ar-SA{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.ar-SA{
.u_c_5R8F100.normal{
position:relative;

}
}.ar-SA{
.u_c_2BKH101.normal{
position:relative;

}
}.ar-SA{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.ar-SA{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.ar-SA{
.u_c_1MD4105.normal{
position:relative;

}
}.ar-SA{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ar-SA{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ar-SA{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ar-SA{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.ar-SA{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_DB6Y112.normal{
position:relative;

}
}.ar-SA{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.ar-SA{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.ar-SA{
.u_c_2BKA116.normal{
position:relative;

}
}.ar-SA{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.ar-SA{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.ar-SA{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.ar-SA{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ar-SA{
.u_c_GAB2125.normal{
position:relative;

}
}.ar-SA{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.ar-SA{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.ar-SA{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}
</style>
